import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditUsers from './AddEditUsers';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [excelList, setExcelList] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
           
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'salesman_in_charge', label: 'Salesman' },
            { id: 'kol_in_charge', label: 'KOL' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'role', label: 'Role' },
            { id: 'user_level', label: 'Level' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
        ])

        setHeadMobileCells([
            { id: 'id', label: 'Store Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'Store Id' },
            { id: 'phone', label: 'Phone' },
            { id: 'email', label: 'Email' },
            { id: 'salesman_in_charge', label: 'Salesman' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'role', label: 'Role' },
            { id: 'user_level', label: 'Level' },
            { id: 'created', label: 'Registered' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'image1', label: 'Image 1' },
            { id: 'image2', label: 'Image 2' },
            { id: 'image3', label: 'Image 3' },
            { id: 'image4', label: 'Image 4' },
        ])

        setEditCells([
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'status_users', label: 'Status' },
            { id: 'phone', label: 'Phone' },
            { id: 'address', label: 'Address' },
        ])

        setAddCells([
            { id: 'area', label: 'Area' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'status_users', label: 'Status' },
            { id: 'phone', label: 'Phone' },
            { id: 'address', label: 'Address' },
        ])

        setExcelList([
            { id: 'id', label: 'Store Id' },
            { id: 'store_name', label: 'Store Name' },
            { id: 'store_address', label: 'Store Address' },
            { id: 'salesman_in_charge', label: 'Salesman' },
            { id: 'kol_in_charge', label: 'KOL' },
            { id: 'ssm_id', label: 'SSM ID' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'role', label: 'Role' },
            { id: 'user_level', label: 'Level' },
            { id: 'created', label: 'Registered' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'image1', label: 'Image 1' },
            { id: 'image2', label: 'Image 2' },
            { id: 'image3', label: 'Image 3' },
            { id: 'image4', label: 'Image 4' },
        ])

        setAddCellsName({ 
            id: '',
            store_address: '',
            first_name: '',
            last_name: '',
            point_users: '',
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            email: '',
            phone: '',
            status_users: '',
            role: '',
            user_redeem_time: ''
         })
    
        setSearchValue("id")
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditUsers}
            control={true}
            orderBy="created" 
            data="users" 
            addItemButton={true}
            addItemText="Add Store"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="users_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            excelList={excelList}
            downloadExcel={true}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  